import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { formatNumber } from '../../../shared/formatNumber';
import { storageMonedaSigno } from '../../../shared/sessionData';
import * as actions from '../../../store/actions/index';

import LineChart from '../../Charts/LineChart';

const LineChequesPropios = (props) => {
  useEffect(() => {
    if (!props.empresa && props.cheques.length === 0) {
      props.onLoadChart();
    }
    if (props.empresa) {
      props.onLoadChart(props.empresa.id);
    }
  }, []);

  return (
    <LineChart
      title={`Cheques emitidos pendientes ${props.empresa ? props.empresa.nombre : ''}`}
      loading={props.loading}
      subTitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalCheques)}`}
      series={props.cheques.map((cheque) => cheque.valor)}
      textoTooltip={'Monto'}
      categories={props.cheques.map((cheque, index) =>
        index === 0 ? cheque.mes : `${new Date(cheque.anio, cheque.mes - 1, 1)}`
      )}
      imgSinDatos={props.cheques.length === 0}
      showXLabels
      height={250}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.ventas.lineChequesPropios.loading,
    cheques: state.ventas.lineChequesPropios.cheques,
    totalCheques: state.ventas.lineChequesPropios.totalCheques
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: (idEmpresa) => dispatch(actions.loadLineChequesPropios(idEmpresa))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineChequesPropios);
